import React from "react";
import { overrideTailwindClasses } from "tailwind-override";

export interface MessageBannerProps {
  additionalClasses?: {
    containerOverrides?: string;
    contentOverrides?: string;
    titleOverrides?: string;
    iconOverrides?: string;
  };
  dataTestId?: string;
  icon?: React.ReactNode;
  messageContent: React.ReactNode | string;
  titleContent?: React.ReactNode | string;
}
const MessageBanner = React.forwardRef<HTMLDivElement, MessageBannerProps>(
  ({ additionalClasses = {}, dataTestId, icon, messageContent, titleContent }, forwardedRef) => {
    const {
      containerOverrides = "",
      contentOverrides = "",
      iconOverrides = "",
      titleOverrides = "",
    } = additionalClasses;

    const baseContainerStyle = "flex items-start text-sm";

    const containerClass = overrideTailwindClasses(`
      ${baseContainerStyle}
      p-4 gap-2 text-black bg-offWhite rounded-md
      ${containerOverrides}
    `);
    const contentClass = overrideTailwindClasses(`
      ${baseContainerStyle}
      ${contentOverrides}
    `);
    const titleClass = overrideTailwindClasses(`font-bold ${titleOverrides}`);

    return (
      <div className={containerClass} data-test-id={dataTestId ?? "message-banner"} ref={forwardedRef}>
        {icon && <div className={iconOverrides}>{icon}</div>}
        <div className={contentClass}>
          {titleContent && <div className={titleClass}>{titleContent}</div>}
          {messageContent}
        </div>
      </div>
    );
  }
);

MessageBanner.displayName = "MessageBanner";

export default MessageBanner;
